<template lang="pug">
.Home
  div.clickText(v-if="!displayMenu" v-html="splitting" :class="availableWords[0] ? availableWords[0].style : ''" @click="addToCart") {{ availableWords[0] && (availableWords[0].style === 'image' ? availableWords[0].text.alt : availableWords[0].text) }}
  img.clickImg(v-show="availableWords[0] && availableWords[0].style === 'image'" :src="imageSrc" :alt="availableWords[0] && availableWords[0].text.alt")
  nav(v-if="displayMenu")
    router-link.animationWork(to="/work") Work
    router-link.animationAbout(to="/about") About
</template>

<script>
import 'splitting/dist/splitting.css'
import 'splitting/dist/splitting-cells.css'
import Splitting from 'splitting'
import { hoverEffect } from '../assets/scripts/utils'

export default {
  name: 'home',
  data() {
    /*
      Each slide is separated by a space " ", use underscore "_" to write multiple words in one slide.
      Use an asterisk "*" to write the slide in big words.
      Use "%" to make the text blink
      You can enter an image
      Use a + sign to discover the beer.
    */
    return {
      sentence:
        // '%Click *Hey ¿Qué tal? Soy María Cerdán redactora creativa [creativa.gif] en publicidad lo que significa que estás en una web donde solo vas a ver anuncios y algún que otro content digital de ese que luego no se ve *nadie No enserio Bienvenido/a! :) Vale veo que sigues dándole al tap Hagamos una apuesta si llegas al final del texto te invito a una birra Lorem ipsum dolor sit amet consectetuer Nah no soy de esas +La birra la tienes en la cesta',
        '%Click *Hey there What’s up I’m María Cerdán an advertising creative director from Barcelona so you’re basically on a website full of *ad$ and some other branded stuff that no one *cares about No seriously welcome Ok looks like you’re just clicking around Let’s make a bet if you get all the way to the end I’ll buy you a *beer Lorem ipsum dolor sit amet consect Nah I’m not one of those The %beer’s waiting for you in the +cart',
      // 'you in the +cart.',

      rawWords: [],
      clicked: 0,
      availableWords: [{ text: '' }],
      isImage: false,
      imageSrc: '',
      displayMenu: false,
      splitting: '',
      hoverEffects: [],
      changeVolumeOnClicks: 0,
      soundId: ''
    }
  },
  methods: {
    split(words) {
      this.splitting = Splitting.html({
        content: `${words}`,
        by: 'chars'
      })
    },
    parseText(rawTxt, id) {
      let text = ''
      let style = ''
      const isImage = rawTxt.match(/^\[(.*)\](.*)$/)
      if (isImage) {
        style = 'image'
        text = { alt: isImage[2], src: isImage[1] }
      } else if (rawTxt[0] === '*') {
        style = 'big'
        text = rawTxt.slice(1)
      } else if (rawTxt[0] === '%') {
        style = 'blink'
        text = rawTxt.slice(1)
      } else if (rawTxt[0] === '+') {
        style = 'birra'
        text = rawTxt.slice(1)
      } else {
        style = null
        text = rawTxt
      }
      return { id, text, style, inCart: false }
    },
    display() {
      if (this.availableWords.length > 0) {
        if (
          this.availableWords[1] &&
          this.availableWords[1].style === 'image'
        ) {
          const src = require(`@/assets/images/${this.availableWords[1].text.src}`)
          this.imageSrc = src
        }

        const currentWordId = this.availableWords[0].id
        this.$store.commit('addToCart', currentWordId)

        if (this.availableWords.length > 1) {
          this.split(this.availableWords[1].text)
        }

        if (this.availableWords.length === 1) {
          this.displayMenu = true
          this.$store.commit('openCart', true)
        }
      }
    },
    addToCart() {
      this.clicked++
      this.changeVolumeOnClicks++
      if (this.clicked <= 1) {
        setTimeout(() => {
          hoverEffect()
          this.clicked = 0
        }, 2500)
      }

      var audio = this.createjs.Sound.play(this.soundId)

      if (this.changeVolumeOnClicks > 1) {
        audio.volume = 0.7
      }
      if (this.changeVolumeOnClicks > 2) {
        audio.volume = 0.4
      }
      if (this.changeVolumeOnClicks > 3) {
        audio.volume = 0.2
      }
      if (this.changeVolumeOnClicks > 4) {
        audio.volume = 0.1
      }

      this.display()
    }
  },
  created() {
    this.soundId = 'sonido'
    this.createjs.Sound.registerSound(
      require('@/assets/sonido.mp3'),
      this.soundId
    )
  },
  mounted() {
    this.$emit('navigationName', 'home')
    if (this.words.filter(word => word.inCart).length === 0) {
      this.rawWords = this.sentence.split(' ').map(t => t.replace('_', ' '))
      this.$store.commit('setWords', this.rawWords.map(this.parseText))
      var listOfarray = this.rawWords.map(this.parseText)
      this.split(listOfarray[0].text)
    } else {
      this.availableWords = this.$store.state.words.filter(word => !word.inCart)
      if (this.availableWords.length > 0) {
        this.split(this.availableWords[0].text)
      }
    }
    this.displayMenu =
      this.$store.state.words.filter(word => !word.inCart).length <= 1

    this.$root.$on('addToCart', () => {
      this.addToCart()
    })
  },
  computed: {
    words() {
      return this.$store.state.words
    },
    archivoSonido() {
      return require('@/assets/sonido.mp3')
    }
  },
  watch: {
    words(newWords, oldWords) {
      this.availableWords = newWords.filter(word => !word.inCart)
    }
  }
}
</script>

<style lang="scss" scoped>
.Home {
  ::-moz-selection {
    color: none;
    background: none;
  }
  ::selection {
    color: none;
    background: none;
  }
  .clickImg {
    position: fixed;
    object-fit: contain;
    width: 100vw;
    height: 100vh;
    padding: $margins-m;
    z-index: -1;
    cursor: pointer;

    @include desktop {
      @include grid(1, 6);
      width: unset;
      position: fixed;
      padding: $margins-d;
    }
  }

  .clickText {
    @include grid(0, 8);
    text-align: center;
    display: block;
    font-size: 2.8rem;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1;
    font-weight: bold;
    cursor: pointer;
    outline: none;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    z-index: 1;
    color: black;

    @media screen and (min-width: 350px) {
      font-size: $fs-xxl;
    }

    &::selection {
      background: transparent;
      outline: none;
    }

    &.small {
      font-size: $fs;
      outline: none;
    }

    &.big {
      font-size: 25vw;
      text-transform: uppercase;
      outline: none;

      @media screen and (max-width: 900px) {
        font-size: 24vw;
      }
    }

    &.blink {
      animation: blink 1s infinite;
      outline: none;

      @keyframes blink {
        from,
        9%,
        20%,
        29%,
        40%,
        49% {
          opacity: 0;
        }
        10%,
        19%,
        30%,
        39%,
        50%,
        to {
          opacity: 1;
        }
      }
      &.word {
        z-index: -1;
        outline: none;
        :focus {
          outline: none;
        }

        &.char {
          outline: none;

          :focus {
            outline: none;
          }
        }
      }
    }

    @include desktop {
      @include grid(0, 8);
      font-size: $fs-xxxl;
    }
  }

  nav {
    @include grid(0, 8);
    text-align: center;
    display: block;
    font-size: $fs-xxl;
    height: 100vh;
    padding: 30vh 0;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1;
    font-weight: bold;
    flex-direction: column;

    a {
      color: black;
      text-decoration: none;
      opacity: 0.5;
      margin: 1rem 0;

      @media screen and (max-width: 900px) {
        margin: 0.6rem 0;
      }

      &:hover {
        opacity: 1;
      }
    }

    @include desktop {
      @include grid(0, 8);
      font-size: $fs-xxxl;
    }
  }

  .animationWork {
    animation: work 2s;

    @keyframes work {
      0% {
        transform: translate(0, -40vh);
        opacity: 0;
      }
      100% {
        transform: auto;
        opacity: 0.5;
      }
    }
  }

  .animationAbout {
    animation: about 2s;

    @keyframes about {
      0% {
        transform: translate(0, 50vh);
        opacity: 0;
      }
      100% {
        transform: auto;
        opacity: 0.5;
      }
    }
  }
}
</style>
